(() => {
  const formatMoney = (cents) =>
    `$${(Number(cents) / 100).toFixed(2)}`;

  const initializePackCards = (grid) => {
    if (grid.dataset.frPackCardsReady === 'true') return true;

    const variantPicker = document.querySelector(
      'variant-radios, variant-selects'
    );

    const productJson = variantPicker?.querySelector(
      'script[type="application/json"]'
    );

    if (!variantPicker || !productJson) return false;

    let variants;

    try {
      variants = JSON.parse(productJson.textContent);
    } catch (error) {
      console.error(
        'Folk Revival: Could not read product variant data.',
        error
      );
      return false;
    }

    const cards = [...grid.querySelectorAll('.fr-pack-card')];
    const isPouch = grid.dataset.productKind === 'pouch';

    const getVariant = (card) =>
      variants.find(
        (variant) => variant.title === card.dataset.pack
      ) || variants[Number(card.dataset.frPackIndex)];

    const getNativeInput = (card) =>
      [...variantPicker.querySelectorAll('input[type="radio"]')]
        .find((input) => input.value === card.dataset.pack);

    const getSelectedPlanId = () => {
      const selectedPlan = document.querySelector(
        '#appstle_subscription_widget0 input[name="selling_plan"]:checked'
      );

      return selectedPlan?.value
        ? Number(selectedPlan.value)
        : null;
    };

    const getPrice = (variant) => {
      const planId = getSelectedPlanId();

      if (!planId) return Number(variant.price);

      const allocation = (
        variant.selling_plan_allocations || []
      ).find(
        (item) => Number(item.selling_plan_id) === planId
      );

      return allocation
        ? Number(allocation.price)
        : Number(variant.price);
    };

    const updateCards = () => {
      const firstCard = cards[0];
      const firstVariant = firstCard
        ? getVariant(firstCard)
        : null;

      if (!firstCard || !firstVariant) return;

      const firstUnits =
        Number(firstCard.dataset.unitCount) || 1;

      const firstUnitPrice =
        getPrice(firstVariant) / firstUnits;

      cards.forEach((card, index) => {
        const variant = getVariant(card);
        if (!variant) return;

        const units = Number(card.dataset.unitCount) || 1;
        const price = getPrice(variant);
        const unitPrice = price / units;

        const priceElement =
          card.querySelector('.fr-pack-price');

        const unitElement =
          card.querySelector('.fr-pack-unit');

        const savingElement =
          card.querySelector('.fr-pack-saving');

        if (priceElement) {
          priceElement.textContent = formatMoney(price);
        }

        if (unitElement) {
          unitElement.textContent = isPouch
            ? `${formatMoney(Math.round(unitPrice))} per serving`
            : `${formatMoney(Math.round(unitPrice))} per cup`;
        }

        if (savingElement && index > 0) {
          const comparablePrice = firstUnitPrice * units;
          const savings = Math.max(
            0,
            Math.round(comparablePrice - price)
          );

          const savingsPercent = comparablePrice > 0
            ? Math.round((savings / comparablePrice) * 100)
            : 0;

          savingElement.textContent = savings > 0
            ? `Save ${formatMoney(savings)} (${savingsPercent}%)`
            : '\u00A0';
        }

        const nativeInput = getNativeInput(card);
        const selected = Boolean(nativeInput?.checked);

        card.classList.toggle('is-selected', selected);
        card.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );
      });
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const nativeInput = getNativeInput(card);
        if (!nativeInput) return;

        nativeInput.checked = true;
        nativeInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        window.setTimeout(updateCards, 150);
      });
    });

    document.addEventListener('change', (event) => {
      if (
        event.target.matches(
          'variant-radios input[type="radio"], ' +
          '#appstle_subscription_widget0 input[name="selling_plan"]'
        )
      ) {
        window.setTimeout(updateCards, 150);
      }
    });

    const appstleWidget = document.querySelector(
      '#appstle_subscription_widget0'
    );

    if (appstleWidget) {
      const observer = new MutationObserver(updateCards);

      observer.observe(appstleWidget, {
        subtree: true,
        childList: true,
        attributes: true
      });
    }

    grid.dataset.frPackCardsReady = 'true';
    variantPicker.classList.add('fr-native-variant-picker--hidden');
    updateCards();
    const appstlePricingTimer = window.setInterval(() => {
  if (document.querySelector('#appstle_subscription_widget0')) {
    updateCards();
    window.clearInterval(appstlePricingTimer);
  }
}, 250);

window.setTimeout(() => {
  window.clearInterval(appstlePricingTimer);
}, 15000);

    return true;
  };
  const getSelectedPack = () => {
    const checkedInputs = [
      ...document.querySelectorAll(
        'variant-radios input[type="radio"]:checked'
      )
    ];

    const packInput = checkedInputs.find((input) =>
      /^(6|12|24|48)\s*Pack$/i.test(input.value.trim())
    );

    return packInput?.value || null;
  };

  const getSelectedSellingPlan = () =>
    document.querySelector('input[name="selling_plan"]:checked')?.value || null;

  const initializeFlavorNavigation = () => {
    if (
      document.documentElement.dataset.frFlavorNavigationReady === 'true'
    ) {
      return;
    }

    document.documentElement.dataset.frFlavorNavigationReady = 'true';

    document.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest(
        '.product_page_flavour a[href]'
      );

      if (!link) return;

      const linkLabel = link.textContent.trim().toLowerCase();

      // Leave the Maple Cup/Pouch package selector alone.
      if (linkLabel === 'cup' || linkLabel === 'pouch') return;

      const selectedPack = getSelectedPack() || '6 Pack';
      const destinationUrl = new URL(
        link.href,
        window.location.origin
      );

      event.preventDefault();

      try {
        const response = await fetch(
          `${destinationUrl.pathname}.js`
        );

        if (!response.ok) {
          throw new Error(
            `Product request failed: ${response.status}`
          );
        }

        const destinationProduct = await response.json();

        const possibleVariants =
          destinationProduct.variants.filter((variant) => {
            const options = variant.options || [];

            return (
              variant.title === selectedPack ||
              options.includes(selectedPack)
            );
          });

        const matchingVariant =
          possibleVariants.find((variant) =>
            (variant.options || []).includes('Cup')
          ) || possibleVariants[0];

        if (matchingVariant) {
          destinationUrl.searchParams.set(
            'variant',
            matchingVariant.id
          );
        }

        const sellingPlan = getSelectedSellingPlan();

        if (sellingPlan) {
          destinationUrl.searchParams.set(
            'selling_plan',
            sellingPlan
          );
        }

        destinationUrl.searchParams.delete('view');

        window.location.href = destinationUrl.toString();
      } catch (error) {
        console.error(
          'Folk Revival: could not preserve pack size.',
          error
        );

        window.location.href = link.href;
      }
    });
  };
  const updateActiveFlavorLinks = () => {
    const currentPath = window.location.pathname.replace(/\/$/, '');

    document
      .querySelectorAll('.product_page_flavour li')
      .forEach((item) => {
        const link = item.querySelector('a[href]');

        if (!link) return;

        const linkPath = new URL(
          link.href,
          window.location.origin
        ).pathname.replace(/\/$/, '');

        const isActive = linkPath === currentPath;

        item.classList.toggle('active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
  };

  updateActiveFlavorLinks();
  initializeFlavorNavigation();
  const start = () => {
    const grids = [
      ...document.querySelectorAll('[data-fr-pack-cards]')
    ];

    if (!grids.length) return false;

    return grids.every(initializePackCards);
  };

  if (!start()) {
    const initializationTimer = window.setInterval(() => {
      if (start()) {
        window.clearInterval(initializationTimer);
      }
    }, 250);

    window.setTimeout(() => {
      window.clearInterval(initializationTimer);
    }, 15000);
  }
})();